import React from 'react'
import { motion } from 'framer-motion'

import { AppWrap } from '../../wrapper'
import { images } from '../../constants'
import './Header.scss'; 

const scaleVariants = {
  whileInView: {
    scale: [0,1],
    opacity: [0,1],
    transition: {
      duration: 1,
      ease: 'easeInOut'
    }
  }
}

const Header = () => {
  return (

    // Div wrapping our Hero/Header component 
    <div className='app__header app__flex'>

      <motion.div
        // Animation properties for motion.div
        // The animation is going to animate from left to right (x) and from invisible to visible (opacity)
        whileInView={{ x: [-100,0], opacity : [0,1]}}
        transition={{ duration: 0.5 }}
        className='app__header-info'
      >
        <div className='app__header-badge'>

          <div className='badge-cmp app__flex'>
            <span>🤫</span>
            <div style={{marginLeft: 20 }}>
              <p className='p-text'>Hello, I am</p>
              <h1 className='head-text'>TWZ</h1>
            </div>
          </div>

          <div className='tag-cmp app__flex'>
            <p className='p-text'>CS Undergraduate</p>
            <p className='p-text'>Technopreneur</p>
          </div>

        </div>
      </motion.div>

      <motion.div
        // Animation Properties 
        whileInView={{ opacity : [0,1]}}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className='app__header-img'
      >
        {/* Hero Image */}
        <img src={images.profile} alt="profile_bg" />
        {/* Hero Image Background */}
        {/* Note : Framer motion has self closing tags */}
        <motion.img
          // Animation Properties
          whileInView={{ scale : [0,1]}}
          transition={{ duration: 1, ease: 'easeInOut' }}
          src={images.circle}
          alt='profile_circle'
          className='overlay_circle'
        />
      </motion.div>

      <motion.div
        // variant allows us to provide different variants on how we want to scale different elements inside this div
        // scaleVariants is the object with the respective properties defined above
        variant={scaleVariants}
        whileInView={scaleVariants.whileInView}
        className='app__header-circles'
      >
        {/* Floating bubbles of images of different technologies behind Hero Image */}
        {[images.react, images.python, images.c].map((circle, index) => (
          <div className='circle-cmp app__flex' key={`circle-${index}`}>
            <img src={circle} alt="circle" />
          </div>
        ))}
      </motion.div>
    </div>
  )
}

// We are wrapping the entire Header section using our HOC AppWrap 
// We are passing in our entire Header component and 'home' as id 
export default AppWrap(Header, 'home');